import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ImageWrapper = styled.div`
  margin-bottom: 52px;
`

export const Message = styled.p`
  color: var(--color-text-subtle);
  margin: 0;
  text-align: center;
`

export const Image = styled.img`
  width: 230px;
  height: 260px;
  margin-bottom: 10px;

  .dark &,
  .vrDark & {
    filter: invert(1) hue-rotate(180deg);
    opacity: 0.6;
  }
`
